<template>
  <div>
    <!-- <p>layoutComponent-style</p> -->
    <asyncPluginSettingSubmit
      v-if="options.pluginName"
      :pluginName="options.pluginName"
      componentName="layoutComponent"
      :options="options"
      type="Style"
      :rect_id="rect_id"
      :container_id="container_id"
    />
  </div>
</template>

<script>
export default {
  props: {
    options: { type: Object },
    container_id: { type: [Number, String] },
    rect_id: { type: [Number, String] }
  },
}
</script>

<style></style>
